export default __webpack_public_path__ + "static/record-evolution-screenshot-7da92797b9209f045ac977532bd77c14.png";